export default "__VITE_ASSET__BSJ23_3v__"